/*
 * rheincool — Scroll-Choreografie (HANDOFF.md §10)
 * - [data-reveal]            Sektion faded beim Einscrollen ein (gestaffelt 80 ms
 *                            je [data-reveal-child] innerhalb des Containers)
 * - [data-countup="1234"]    Zahl zählt beim Einscrollen hoch (1,4 s ease-out),
 *                            optional data-countup-suffix / data-countup-decimals
 * prefers-reduced-motion: alles sofort sichtbar, Endwerte ohne Animation.
 */
(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const formatNumber = (value, decimals) =>
    new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value);

  const setFinalValue = (el) => {
    const target = parseFloat(el.dataset.countup);
    const decimals = parseInt(el.dataset.countupDecimals || '0', 10);
    el.textContent = formatNumber(target, decimals) + (el.dataset.countupSuffix || '');
  };

  const runCountup = (el) => {
    if (el.dataset.countupDone) return;
    el.dataset.countupDone = 'true';
    if (reducedMotion.matches) {
      setFinalValue(el);
      return;
    }
    const target = parseFloat(el.dataset.countup);
    const decimals = parseInt(el.dataset.countupDecimals || '0', 10);
    const suffix = el.dataset.countupSuffix || '';
    const duration = 1400;
    const start = performance.now();
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      el.textContent = formatNumber(target * easeOut(progress), decimals) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const revealElement = (el) => {
    const children = el.querySelectorAll('[data-reveal-child]');
    if (reducedMotion.matches || !children.length) {
      el.classList.add('is-revealed');
      children.forEach((child) => child.classList.add('is-revealed'));
    } else {
      el.classList.add('is-revealed');
      children.forEach((child, index) => {
        setTimeout(() => child.classList.add('is-revealed'), index * 80);
      });
    }
    el.querySelectorAll('[data-countup]').forEach(runCountup);
    if (el.dataset.countup !== undefined) runCountup(el);
  };

  const init = () => {
    const targets = document.querySelectorAll('[data-reveal], [data-countup]');
    if (!targets.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach(revealElement);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealElement(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );
    targets.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
